import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "weight",
  standalone: false
})
export class WeightPipe implements PipeTransform {
  transform(
    value: number,
    style: Intl.NumberFormatOptionsStyle,
    unit: string
  ): string {
    return new Intl.NumberFormat("it-IT", {
      style,
      unit
    }).format(value);
  }
}
